const privacyPolicyHtml = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Privacy Policy - Class Copilot</title>
  <style>
    body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      line-height: 1.7;
      background: #f7f7f7;
      color: #222;
    }

    .container {
      max-width: 900px;
      margin: 40px auto;
      background: #ffffff;
      padding: 40px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    }

    h1, h2 {
      color: #191645;
    }

    h1 {
      margin-top: 0;
      font-size: 32px;
      text-align: center;
    }

    h2 {
      margin-top: 32px;
      font-size: 22px;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 8px;
    }

    p {
      margin: 12px 0;
    }

    ul {
      margin: 10px 0 10px 20px;
    }

    li {
      margin-bottom: 8px;
    }

    .meta {
      text-align: center;
      color: #666;
      margin-bottom: 30px;
    }

    .contact-box {
      background: #f3f4ff;
      padding: 20px;
      border-radius: 10px;
      margin-top: 20px;
    }

    a {
      color: #191645;
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }

    .note {
      background: #fff8e1;
      border-left: 4px solid #f4b400;
      padding: 14px 16px;
      margin: 16px 0;
      border-radius: 6px;
    }

    @media (max-width: 768px) {
      .container {
        margin: 16px;
        padding: 24px;
      }

      h1 {
        font-size: 26px;
      }

      h2 {
        font-size: 20px;
      }
    }
  </style>
</head>
<body>
  <div class="container">
    <h1>Privacy Policy</h1>
    <p class="meta">
      <strong>Class Copilot</strong><br />
      Effective Date: 2026-04-19<br />
      Last Updated: 2026-04-19
    </p>

    <h2>1. Introduction</h2>
    <p>
      This Privacy Policy explains how <strong>I T WAVES (PRIVATE) LIMITED</strong>
      ("we", "our", or "us") collects, uses, stores, and protects information when
      you use the <strong>Class Copilot</strong> mobile application and related services.
    </p>
    <p>
      By using Class Copilot, you agree to the practices described in this Privacy Policy.
    </p>

    <h2>2. Developer Information</h2>
    <p>
      <strong>Developer / Legal Entity:</strong> I T WAVES (PRIVATE) LIMITED<br />
      <strong>App Name:</strong> Class Copilot<br />
      <strong>Package Name:</strong> lk.classcopilot.app
    </p>

    <h2>3. Information We Collect</h2>
    <p>We may collect the following categories of information:</p>
    <ul>
      <li>Name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>User profile details</li>
      <li>Teacher and student account information</li>
      <li>Classroom, assignment, and educational content data</li>
      <li>Uploaded files such as PDFs, images, and videos</li>
      <li>Device information, operating system version, and app usage information</li>
      <li>Crash logs, diagnostics, and analytics data</li>
    </ul>

    <h2>4. How We Use Your Information</h2>
    <p>We use the collected information to:</p>
    <ul>
      <li>Provide, operate, and maintain the app</li>
      <li>Create and manage user accounts</li>
      <li>Support teachers, students, and class management features</li>
      <li>Enable assignment sharing, content uploading, and classroom communication</li>
      <li>Send notifications and important service updates</li>
      <li>Improve app performance, stability, and user experience</li>
      <li>Provide customer support and respond to user requests</li>
      <li>Maintain app security and prevent misuse</li>
    </ul>

    <h2>5. Permissions Used by the App</h2>
    <p>Class Copilot may request the following permissions on Android devices:</p>
    <ul>
      <li>
        <strong>INTERNET</strong> \u2013 Used to connect to our servers and load app content.
      </li>
      <li>
        <strong>POST_NOTIFICATIONS</strong> \u2013 Used to send class updates, reminders, announcements, and other notifications.
      </li>
      <li>
        <strong>READ_EXTERNAL_STORAGE</strong> \u2013 Used to select and upload files from the device.
      </li>
      <li>
        <strong>WRITE_EXTERNAL_STORAGE</strong> (Android 9 / API 28 and below) \u2013 Used when saving or handling downloaded or uploaded files.
      </li>
      <li>
        <strong>VIBRATE</strong> \u2013 Used to enhance notification alerts.
      </li>
      <li>
        <strong>CAMERA</strong> \u2013 Used for features such as scanning QR codes or capturing images/documents for upload.
      </li>
    </ul>

    <div class="note">
      Some permissions may only be requested when needed for a specific feature.
    </div>

    <h2>6. Third-Party Services</h2>
    <p>
      We may use trusted third-party services to support app functionality, analytics,
      crash reporting, and notifications.
    </p>
    <p>These services may include:</p>
    <ul>
      <li><strong>Firebase Analytics</strong> \u2013 to understand app usage and improve features</li>
      <li><strong>Firebase Crashlytics</strong> \u2013 to detect and fix app crashes and technical issues</li>
      <li><strong>Firebase Cloud Messaging</strong> \u2013 to deliver push notifications</li>
    </ul>
    <p>
      These providers may collect device identifiers, app interaction data, crash data,
      and technical diagnostics in accordance with their own privacy policies.
    </p>
    <p>
      Firebase Privacy Information:
      <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
        https://firebase.google.com/support/privacy
      </a>
    </p>

    <h2>7. Data Sharing</h2>
    <p>We do not sell your personal information.</p>
    <p>We may share information only in the following situations:</p>
    <ul>
      <li>With teachers, students, or authorized users as required by the app's functionality</li>
      <li>With service providers that help us operate the app and backend infrastructure</li>
      <li>When required by law, regulation, or legal process</li>
      <li>To protect the safety, rights, and security of users, our services, or the public</li>
    </ul>

    <h2>8. Data Retention</h2>
    <p>
      We retain personal data and app-related information only for as long as necessary
      to provide our services, comply with legal obligations, resolve disputes, and enforce our agreements.
    </p>
    <p>
      Users may contact us to request account deletion or data removal, subject to legal and operational requirements.
    </p>

    <h2>9. Data Security</h2>
    <p>
      We use reasonable administrative, technical, and organizational measures to protect
      your information, including secure communication channels and controlled access to data.
    </p>
    <p>
      However, no internet-based service can be guaranteed to be completely secure.
    </p>

    <h2>10. Children's Privacy</h2>
    <p>
      Class Copilot is designed for educational use and may be used by students under the age of 18
      under the supervision of teachers, schools, parents, or guardians where applicable.
    </p>
    <p>
      We do not knowingly collect more personal information from children than is reasonably necessary
      for providing the educational services of the app.
    </p>
    <p>
      If you believe that a child has provided personal information inappropriately, please contact us
      so we can review and take appropriate action.
    </p>

    <h2>11. Your Rights</h2>
    <p>Depending on your location and applicable laws, you may have the right to:</p>
    <ul>
      <li>Access the personal data we hold about you</li>
      <li>Request correction of inaccurate information</li>
      <li>Request deletion of your information</li>
      <li>Withdraw consent where processing is based on consent</li>
      <li>Contact us regarding privacy concerns or complaints</li>
    </ul>

    <h2>12. International Users</h2>
    <p>
      If you use the app from outside Sri Lanka, please note that your information may be processed
      and stored in countries where our service providers or infrastructure are located.
    </p>

    <h2>13. Changes to This Privacy Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Any changes will be posted on this page
      with an updated "Last Updated" date.
    </p>

    <h2>14. Contact Us</h2>
    <div class="contact-box">
      <p><strong>I T WAVES (PRIVATE) LIMITED</strong></p>
      <p>No 183, Sunanda Mawatha, Walgama, Matara, Southern Province, Sri Lanka</p>
      <p>Email: <a href="mailto:mgmskumara@gmail.com">mgmskumara@gmail.com</a></p>
      <p>Phone: <a href="tel:+94713848468">+94 71 384 8468</a></p>
    </div>
  </div>
</body>
</html>`;

export default privacyPolicyHtml;
